import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useNavigationStore = create(
  persist(
    (set) => ({
      currentProgramme: null,
      currentBatch: null,

      setProgramme: (programme) => {
        set({ currentProgramme: programme });
      },

      setBatch: (batch) => {
        set({ currentBatch: batch });
      },

      clearWorkspace: () => {
        set({ currentProgramme: null, currentBatch: null });
      },
    }),
    {
      name: 'navigation-store', // for localStorage
      partialize: (state) => ({
        currentProgramme: state.currentProgramme,
        currentBatch: state.currentBatch, // Persist both programme and batch
      }),
    }
  )
);

export default useNavigationStore;